module.exports = "<!-- <footer class=\"footer\">\n  <div class=\"container\">\n    <span class=\"text-muted\">\n      Powered by <i class=\"fa fa-heart\" aria-hidden=\"true\" style=\"color: red;\"></i>️ QMedical\n    </span>\n  </div>\n</footer> -->\n"


//////////////////
// WEBPACK FOOTER
// /home/usr/clienti.qmedical/src/app/full-layout/footer/footer.component.html
// module id = ../../../../../src/app/full-layout/footer/footer.component.html
// module chunks = main